module.exports = __webpack_public_path__ + "static/media/qr-code.853d336c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-code.png
// module id = 480
// module chunks = 42